/**
 * Created by afuhr on 05.01.2017.
 */

export const ERRCODE_MISC = "miscError";

export const ERRCODE_BARCODE_IN_USE = "barcodeInUse";
export const HELPTEXT_BARCODE_IN_USE = "Der Barcode ist bereits in Benutzung und kann nicht verwendet werden";

export class ValidatorErrorCodes {

  public static ERRCODE_MISC = ERRCODE_MISC;
  public static ERRCODE_BARCODE_IN_USE = ERRCODE_BARCODE_IN_USE;

}

export class ValidatorErrorHelpTexts {
  public static HELPTEXT_BARCODE_IN_USE = HELPTEXT_BARCODE_IN_USE;
}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/forms/validators/validator-error-codes.ts